import React, { useEffect, useRef, useState } from "react";
import { useModal } from "../../context/ModalContext";

import fullLogo from "../../assets/images/svg/unicornio-brown.svg";

const TextareaQuestion = ({ question, value = "", onChange }) => {
    const inputRef = useRef(null);
    const [localValue, setLocalValue] = useState(value);
    const { openModal, closeModal } = useModal();

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleChange = (e) => {
        const val = e.target.value;
        setLocalValue(val);
        onChange(val);
    };

    const handleBlur = (sym_id) => {
        if (sym_id === 587) {
            const data = {
                icon: fullLogo,
                // progress: 95,
                title: "Atenção",
                content: {
                    description: `Informamos que a Puríssima não manipula medicamentos ou hormônios, e nossos suplementos não substituem a necessidade de manutenção do seu uso. Porém, com o uso regular da sua suplementação, ajustes nos seus medicamentos podem ser necessários ao longo do tempo, sendo fundamental manter o acompanhamento com o seu profissional de saúde.`,
                    button: {
                        label: "Continuar",
                        onClick: () => { closeModal(); }
                    }
                }
            }
            openModal('confirmation', data);
        }
    }

    return (
        <div className="question text-question row mx-0 align-items-center">
            <div className="chat-label col-12 py-3">
                {question.label}
            </div>

            <div className="chat-answer user position-relative col-12 px-0 mw-100">
                <textarea
                    cols={question.cols || 30}
                    rows={question.rows || 6}
                    className="form-control w-100"
                    ref={inputRef}
                    data-id={`masked-input-${question.sym_id}`}
                    value={localValue}
                    onBlur={e => handleBlur(question.sym_id, e)}
                    onChange={handleChange}
                    placeholder={question.placeholder}
                />
                {question.sym_explain && <small>{question.sym_explain}</small>}
            </div>
        </div>
    );
};

export default TextareaQuestion;
